export const WS_URL = process.env.NODE_ENV === 'production'?'ws://xf.lcjaxf.cn:51800/':'ws://192.168.1.15:51808/';
// export const WS_URL = 'ws://192.168.1.14:51808/';